<template>
  <v-dialog
    v-model="internalValue"
    max-width="520"
    persistent
    overlay-color="#000000"
    overlay-opacity="0.92"
    content-class="carnival-promo-dialog"
  >
    <v-card class="carnival-promo-card">
      <!-- Banner com tema Carnaval -->
      <div class="carnival-banner">
        <v-btn icon small class="close-btn" @click="close" aria-label="Fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="confetti-left">🎊</div>
        <div class="confetti-right">🎉</div>
        <div class="icon-circle-carnival">
          <v-icon color="#0f0f10" size="32">mdi-party-popper</v-icon>
        </div>
        <div class="headline-carnival">CARNAVAL 2026</div>
        <div class="subhead-carnival">Promoção especial por tempo limitado!</div>
      </div>

      <!-- Conteúdo -->
      <div class="body-carnival">
        <h2 class="section-title-carnival">
          10% de desconto em qualquer plano VIP!
        </h2>
        <p class="description-carnival">
          Aproveite o <span class="highlight-gold">Carnaval</span> com desconto
          exclusivo em todos os planos VIP da Clutch Arena. Use o cupom abaixo
          antes que a promoção acabe!
        </p>

        <!-- Cupom -->
        <div class="coupon-box" @click="copyCoupon">
          <div class="coupon-label">CUPOM DE DESCONTO</div>
          <div class="coupon-code-row">
            <span class="coupon-code">CARNAVAL2026</span>
            <v-icon size="20" :color="couponCopied ? '#4caf50' : '#ffd54f'">
              {{ couponCopied ? 'mdi-check-circle' : 'mdi-content-copy' }}
            </v-icon>
          </div>
          <div class="coupon-hint">
            {{ couponCopied ? 'Cupom copiado!' : 'Clique para copiar' }}
          </div>
        </div>

        <!-- Info de validade -->
        <div class="promo-validity">
          <v-icon size="16" color="#ff9800">mdi-clock-outline</v-icon>
          <span>Válido até <strong>19 de fevereiro de 2026</strong></span>
        </div>

        <!-- Destaques -->
        <div class="features-carnival">
          <div class="feature-item-carnival">
            <div class="feature-icon-carnival">
              <v-icon size="16">mdi-percent</v-icon>
            </div>
            <div class="feature-text-carnival">
              <div class="feature-title-carnival">10% OFF</div>
              <div class="feature-sub-carnival">
                Em qualquer plano VIP disponível
              </div>
            </div>
          </div>

          <div class="feature-item-carnival">
            <div class="feature-icon-carnival">
              <v-icon size="16">mdi-star</v-icon>
            </div>
            <div class="feature-text-carnival">
              <div class="feature-title-carnival">Todos os benefícios VIP</div>
              <div class="feature-sub-carnival">
                Acesse vantagens exclusivas na plataforma
              </div>
            </div>
          </div>
        </div>

        <div class="actions-carnival">
          <v-btn large class="cta-primary-carnival" @click="goToPlans">
            <v-icon left size="20">mdi-crown</v-icon>
            Ver Planos VIP
          </v-btn>
          <v-btn text class="cta-secondary-carnival" @click="close">Depois</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CarnivalPromoPopup",
  props: {
    value: { type: Boolean, default: false },
    storageKey: {
      type: String,
      default: "carnival-promo-2026-dismissed"
    }
  },
  data() {
    return {
      internalValue: this.value,
      couponCopied: false
    };
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
    internalValue(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    // Verifica se a promoção ainda é válida (até 19/02/2026 23:59:59 horário de Brasília UTC-3)
    const promoEnd = new Date("2026-02-20T02:59:59Z"); // 19/02/2026 23:59:59 BRT
    const now = new Date();

    if (now > promoEnd) {
      // Promoção expirou, não mostra
      this.internalValue = false;
      return;
    }

    try {
      const dismissed = localStorage.getItem(this.storageKey);
      if (!dismissed && this.value === false) {
        this.internalValue = true;
        this.$emit("input", true);
      }
    } catch (e) {
      console.warn("Falha ao acessar localStorage na popup:", e);
      if (this.value === false) {
        this.internalValue = true;
        this.$emit("input", true);
      }
    }
  },
  methods: {
    close() {
      try {
        localStorage.setItem(this.storageKey, "1");
      } catch (e) {
        console.warn("Falha ao gravar no localStorage:", e);
      }
      this.internalValue = false;
    },
    copyCoupon() {
      navigator.clipboard
        .writeText("CARNAVAL2026")
        .then(() => {
          this.couponCopied = true;
          setTimeout(() => {
            this.couponCopied = false;
          }, 2500);
        })
        .catch(err => {
          console.error("Erro ao copiar cupom:", err);
        });
    },
    goToPlans() {
      try {
        localStorage.setItem(this.storageKey, "1");
      } catch (e) {
        console.warn("Falha ao gravar no localStorage:", e);
      }
      this.internalValue = false;
      this.$router.push("/plans");
    }
  }
};
</script>

<style scoped>
/* ============================================
   DIALOG Z-INDEX MÁXIMO
   ============================================ */
::v-deep .carnival-promo-dialog {
  z-index: 9999 !important;
}

::v-deep .v-overlay {
  z-index: 9998 !important;
}

/* ============================================
   CARD PRINCIPAL
   ============================================ */
.carnival-promo-card {
  background: linear-gradient(180deg, #1a1a1f 0%, #111316 100%);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5),
    0 0 60px rgba(255, 193, 7, 0.08);
  max-height: 90vh;
  overflow-y: auto;
}

/* Scrollbar */
.carnival-promo-card::-webkit-scrollbar {
  width: 8px;
}

.carnival-promo-card::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.carnival-promo-card::-webkit-scrollbar-thumb {
  background: rgba(255, 193, 7, 0.4);
  border-radius: 4px;
}

.carnival-promo-card::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 193, 7, 0.6);
}

/* ============================================
   BANNER CARNAVAL
   ============================================ */
.carnival-banner {
  position: relative;
  background: linear-gradient(135deg, #e65100 0%, #f57c00 30%, #ff9800 60%, #ffc107 100%);
  padding: 22px 16px 18px 16px;
  text-align: center;
  overflow: hidden;
}

.confetti-left,
.confetti-right {
  position: absolute;
  font-size: 32px;
  top: 12px;
  opacity: 0.7;
  animation: float 3s ease-in-out infinite;
}

.confetti-left {
  left: 16px;
}

.confetti-right {
  right: 16px;
  animation-delay: 1.5s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-6px) rotate(10deg);
  }
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  color: rgba(0, 0, 0, 0.7) !important;
  background: rgba(255, 255, 255, 0.25) !important;
  width: 32px !important;
  height: 32px !important;
  z-index: 2;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.4) !important;
}

.icon-circle-carnival {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.headline-carnival {
  font-family: "Orbitron", system-ui, sans-serif;
  font-weight: 800;
  font-size: 22px;
  color: #0f0f10;
  margin-bottom: 2px;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.2);
}

.subhead-carnival {
  font-weight: 600;
  font-size: 13px;
  color: rgba(15, 15, 16, 0.8);
}

/* ============================================
   BODY
   ============================================ */
.body-carnival {
  padding: 22px 22px 22px 22px;
  background: #111316;
}

/* ============================================
   TEXTOS
   ============================================ */
.section-title-carnival {
  font-family: "Orbitron", system-ui, sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: 1.3;
  margin: 0 0 10px 0;
  color: #ffd54f;
}

.description-carnival {
  color: #b0b5c0;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 18px 0;
}

.highlight-gold {
  color: #ffd54f;
  font-weight: 700;
}

/* ============================================
   CUPOM
   ============================================ */
.coupon-box {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.08) 100%);
  border: 2px dashed rgba(255, 193, 7, 0.5);
  border-radius: 12px;
  padding: 14px 18px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 14px;
}

.coupon-box:hover {
  border-color: rgba(255, 193, 7, 0.8);
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 152, 0, 0.12) 100%);
  transform: translateY(-1px);
}

.coupon-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #ff9800;
  margin-bottom: 6px;
}

.coupon-code-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.coupon-code {
  font-family: "Orbitron", monospace;
  font-size: 22px;
  font-weight: 800;
  color: #ffd54f;
  letter-spacing: 3px;
}

.coupon-hint {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 4px;
}

/* ============================================
   VALIDADE
   ============================================ */
.promo-validity {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  color: #b0b5c0;
  margin-bottom: 18px;
  padding: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.promo-validity strong {
  color: #ff9800;
}

/* ============================================
   FEATURES
   ============================================ */
.features-carnival {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 0 20px 0;
}

.feature-item-carnival {
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 10px;
  align-items: center;
  background: rgba(255, 193, 7, 0.05);
  padding: 10px;
  border-radius: 10px;
  border: 1px solid rgba(255, 193, 7, 0.15);
}

.feature-icon-carnival {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #f57c00 0%, #ff9800 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon-carnival .v-icon {
  color: #ffffff !important;
}

.feature-text-carnival {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.feature-title-carnival {
  font-weight: 700;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.4;
}

.feature-sub-carnival {
  color: #b0b5c0;
  font-size: 13px;
  line-height: 1.4;
}

/* ============================================
   BOTÕES
   ============================================ */
.actions-carnival {
  display: flex;
  gap: 10px;
  align-items: center;
}

.cta-primary-carnival {
  background: linear-gradient(135deg, #e65100 0%, #f57c00 50%, #ff9800 100%) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  height: 44px !important;
  padding: 0 22px !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(255, 152, 0, 0.35) !important;
  font-size: 14px !important;
  flex: 1;
}

.cta-primary-carnival:hover {
  box-shadow: 0 6px 18px rgba(255, 152, 0, 0.5) !important;
  transform: translateY(-1px) !important;
}

.cta-secondary-carnival {
  color: #9ca3af !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

.cta-secondary-carnival:hover {
  color: #d1d5db !important;
}
</style>
